/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LlmLayoutTrigger } from '../../models/llm-layout-trigger';

export interface LlmConfigurationGetTriggersLayoutIdGet$Params {
  layoutId: number;
}

export function llmConfigurationGetTriggersLayoutIdGet(http: HttpClient, rootUrl: string, params: LlmConfigurationGetTriggersLayoutIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LlmLayoutTrigger>>> {
  const rb = new RequestBuilder(rootUrl, llmConfigurationGetTriggersLayoutIdGet.PATH, 'get');
  if (params) {
    rb.path('layoutId', params.layoutId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LlmLayoutTrigger>>;
    })
  );
}

llmConfigurationGetTriggersLayoutIdGet.PATH = '/LLMConfiguration/GetTriggers/{layoutId}';
